


































































































import { Component, Vue, Prop } from "vue-property-decorator";

import EntityFiles from "@/components/fileManager/EntityFiles.vue";
import course from "@/getinfo-api/course";
import api from "@/getinfo-api";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { Registration as IRegistration } from "@/api-v2/course/models/registration";
import courseRegistrations from "@/getinfo-api/courseRegistrations";
import Modal from "@/components/form/Modal.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import UserStudentFiles from "@/components/user/UserStudentFiles.vue";
import listeners, {
  CourseListenersListParams
} from "@/getinfo-api/course-listeners";
import { getCurrentCompanyId } from "@/plugins/roles";

@Component({
  components: { UserStudentFiles, CustomButton, Modal, EntityFiles }
})
export default class UserFilesFromDocuments extends Vue {
  @Prop() userId!: string;
  listeners: any[] = [];
  registrations: IRegistration[] = [];
  isLoading: boolean = false;

  data() {
    return {};
  }
  get selectedCompany() {
    return getCurrentCompanyId();
  }
  async init() {
    this.isLoading = true;
    try {
      await course({
        listenerUserIds: [this.userId],
        companyIds: this.selectedCompany ? [this.selectedCompany] : undefined,
        limit: 999
      }).then(res => {
        res.data.courses.forEach(async course => {
          await api.CourseApi.listenerGetByUser(course.id, this.userId).then(
            res => {
              this.listeners.push(...res.data.listeners);
            }
          );
        });
      });

      await courseRegistrations({
        studentUserIds: [this.userId],
        companyId: this.selectedCompany ?? undefined,
        limit: 999
      }).then(res => {
        this.registrations = res.data.items;
      });
    } finally {
      this.isLoading = false;
    }
  }

  mounted() {
    this.init();
  }
}
